
export function isObject (value) {
  return (typeof value === 'object' && value !== null) || typeof value === 'function'
}

export function isUndefined (value) {
  return value === undefined
}

export function isNumber (value) {
  return (
    typeof value === 'number' &&
    Number.isFinite(value) &&
    !Number.isNaN(value)
  )
}

export function isInteger (value) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return false
  const abs = Math.abs(value)
  return Math.floor(abs) === abs
}
